export const ROUTES = {
    LOGIN: "/login",
    WORKPLACES: "/workplaces",
    EXCEPTIONS: "/workplaces/exceptions",
    ASSIGNEDSPACE: "/workplaces/assignedspaces",
    MYSETTINGS: "/workplaces/mysettings/:id",
    getMySettings: (id: string | number) =>
        `/workplaces/mysettings/${id}`,
    TEAMSWORKPLACES: "/workplaces/myteams/:id/:department",
    getTeamsWorkplaces: (id: string | number, department: string) =>
        `/workplaces/myteams/${id}/${department}`,
};